// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const arceus: PokeData = {
  "id": 493,
  "name": "arceus",
  "height": 32,
  "weight": 3200,
  "base_experience": 324,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [
    "hyper-beam",
    "seismic-toss",
    "confusion",
    "quick-attack",
    "recover",
    "perish-song",
    "extreme-speed",
    "ancient-power",
    "future-sight",
    "refresh",
    "hyper-voice",
    "cosmic-power",
    "extrasensory",
    "calm-mind",
    "gravity",
    "healing-wish",
    "natural-gift",
    "punishment",
    "earth-power",
    "judgment"
  ],
  "moves": [
    "seismic-toss",
    "quick-attack",
    "ancient-power",
    "future-sight",
    "refresh",
    "hyper-voice",
    "calm-mind",
    "healing-wish",
    "earth-power",
    "tri-attack",
    "growl",
    "splash",
    "supersonic"
  ],
  "evolution_chain": {
    "id": 254,
    "item": null,
    "species": [
      {
        "name": "arceus",
        "order": 494,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 133,
    "speed": 133,
    "ability_power": 133
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": false,
  "is_mythical": true,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
